export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_INVOICES_INVOICEPAYMENT",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_INVOICES_INVOICEPAYMENT",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_INVOICES_INVOICEPAYMENT",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_INVOICES_INVOICEPAYMENT",
  DESTROY_FORM: "DESTROY_FORM_INVOICES_INVOICEPAYMENT",
  SET_FORM_ERROR: "SET_FORM_ERROR_INVOICES_INVOICEPAYMENT",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_INVOICES_INVOICEPAYMENT",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_INVOICES_INVOICEPAYMENT",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_INVOICES_INVOICEPAYMENT",
  RESET_STATE: "RESET_STATE_INVOICES_INVOICEPAYMENT",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_INVOICES_INVOICEPAYMENT",
  REMOVE_OBJECT: "REMOVE_OBJECT_INVOICES_INVOICEPAYMENT",
  CLEAR_FETCHED: "CLEAR_FETCHED_INVOICES_INVOICEPAYMENT",

  LIST_URL: "/accounting/invoices/invoicepayment/list/",
  POST_URL: "/accounting/invoices/invoicepayment/",
  PATCH_URL: "/accounting/invoices/invoicepayment/",
  GET_URL: "/accounting/invoices/invoicepayment/",

  STORE_NAME: "invoicePayment",
};
